import EmailConfirmation from './containers/EmailConfirmationContainer'

export default {
  path: '/email-confirmation',
  component: EmailConfirmation
}



// WEBPACK FOOTER //
// ./src/routes/emailConfirmation/index.js